const truncateString = (value, maxLength) => (
  value.length > maxLength ? `${value.slice(0, maxLength)}…` : value
);

export default truncateString;
